import { ResourceType } from '../common/typings';
import { CreativeOptionSourceType } from '../CreativeOptions/typings';
import { GalleryPaneTypes } from '../GalleryPane/typings';

export type AudioPreviewResource = {
    type: PreviewResourceType.AUDIO;
    name: string;
    duration: number;
};

export type ImagePreviewResource = {
    type: PreviewResourceType.IMAGE;
    previewUrl: string;
};

export type OverlayPreviewResource = {
    type: PreviewResourceType.OVERLAY;
    name: string;
};

export enum PreviewResourceType {
    OVERLAY = 'overlay',
    IMAGE = 'image',
    AUDIO = 'audio'
}

export type PreviewResource = AudioPreviewResource | ImagePreviewResource | OverlayPreviewResource;

export enum FileEditorStatus {
    NEW = 'new',
    EDIT = 'edit',
    CONVERTING = 'converting'
}

export interface FileEditorOptions {
    resourceType: ResourceType;
    groupName: string;
    name: string;
}

export interface FileEditorState {
    status: FileEditorStatus;

    fileId: string | null;
    savedFileId?: string | null;

    fromGallery?: boolean;

    preview?: PreviewResource;
    // в случае отмены загрузки ресурса
    // нужно вернуть сохраненное превью
    savedPreview?: PreviewResource;

    hasRecentSource?: boolean;
    hasIdeaSource?: boolean;

    options?: FileEditorOptions;

    longUpload?: boolean;
    loadingFileId?: string | null;
    upload?: boolean;

    // нужно для открытия кропалки для изображений
    cropSourceUrl?: string;
    url?: string;
}

export type FileEditorsState = Record<string, FileEditorState>;

export const GALLERY_PANE_SOURCES = {
    [CreativeOptionSourceType.stock]: GalleryPaneTypes.stock,
    [CreativeOptionSourceType.recent]: GalleryPaneTypes.recent,
    [CreativeOptionSourceType.idea]: GalleryPaneTypes.idea
};
